import { getQuestion, visibleQuestionIds } from "./engine.js";
export const ZOKUJINKA_FLAG = "zokujinka";
/**
 * タグ集計・タイプ判定（純粋関数）。— 仕様書 §3.2 / 設計書 §6
 * フロント（プレビュー）とFunctions（確定値）で同一実装を共有する。
 *
 * 到達していない（＝現在非表示の）設問の回答は集計しない。
 * ユーザーがQ5選択を変えて分岐が捨てられた場合の亡霊回答を除外するため。
 */
export function score(def, answers) {
    const totals = {};
    for (const t of Object.keys(def.tags))
        totals[t] = 0;
    let zokujinkaCount = 0;
    const visible = new Set(visibleQuestionIds(def, answers));
    for (const [qid, selected] of Object.entries(answers)) {
        if (!visible.has(qid))
            continue;
        const q = getQuestion(def, qid);
        if (!q)
            continue; // areaQuestion(Q5)等はタグを持たない
        for (const optId of selected) {
            const opt = q.options.find((o) => o.id === optId);
            if (!opt)
                continue;
            for (const [tag, w] of Object.entries(opt.tags)) {
                totals[tag] = (totals[tag] ?? 0) + w;
            }
            if ((opt.flags ?? []).includes(ZOKUJINKA_FLAG))
                zokujinkaCount += 1;
        }
    }
    const tieRank = new Map();
    def.tieBreakOrder.forEach((t, i) => tieRank.set(t, i));
    const rank = (t) => tieRank.get(t) ?? Number.MAX_SAFE_INTEGER;
    const ranked = Object.keys(totals)
        .map((tag) => ({ tag, score: totals[tag] ?? 0 }))
        .sort((a, b) => (b.score - a.score) || (rank(a.tag) - rank(b.tag)));
    const topThemes = ranked.filter((r) => r.score > 0).slice(0, 3).map((r) => r.tag);
    const topTag = topThemes[0] ?? null;
    const resultTypeId = judgeType(def, topTag);
    return {
        totals,
        ranked,
        topThemes,
        topTag,
        resultTypeId,
        zokujinkaCount,
        zokujinkaWarning: zokujinkaCount >= 2,
    };
}
/** 最上位タグから改善タイプを判定 — 設計書 §6.2 */
export function judgeType(def, topTag) {
    if (topTag) {
        const hit = def.resultTypes.find((rt) => rt.topTagIn.includes(topTag));
        if (hit)
            return hit.id;
    }
    // タグが一切付かなかった場合の既定（AIはじめの一歩）
    const aiFirst = def.resultTypes.find((rt) => rt.topTagIn.includes("T9"));
    return (aiFirst ?? def.resultTypes[def.resultTypes.length - 1]).id;
}
/** 結果画面用のビューを組み立てる（テンプレート・タイプ名・導線を解決）— 設計書 §7 */
export function buildResult(def, answers) {
    const scored = score(def, answers);
    const rt = def.resultTypes.find((t) => t.id === scored.resultTypeId);
    const themes = scored.topThemes.map((tag) => ({
        tag,
        label: def.tags[tag]?.label ?? tag,
        template: def.resultTemplates[tag],
        score: scored.totals[tag] ?? 0,
    }));
    const emp = (answers["Q2"] ?? [])[0];
    const routeDef = (emp && def.routing.byEmployees[emp]) || { primary: "shindan_standard", note: "" };
    const isStaff = (answers["Q3"] ?? [])[0] === "staff";
    return {
        scored,
        view: {
            typeId: rt.id,
            typeName: rt.name,
            typeSummary: rt.summary,
            themes,
            zokujinkaWarning: scored.zokujinkaWarning,
            routing: {
                primary: routeDef.primary,
                note: routeDef.note,
                staffAddon: isStaff ? def.routing.staffAddon : undefined,
            },
            subsidyNote: def.uiTexts["subsidyNote"],
        },
    };
}
//# sourceMappingURL=scoring.js.map